// Array of country objects for the flag dropdown.

import { MCountryOptions } from './country';

// Here is the criteria for the plugin to support a given country/territory
// - It has an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
// - It has it's own country calling code (it is not a sub-region of another country): https://en.wikipedia.org/wiki/List_of_country_calling_codes
// - It has a flag in the region-flags project: https://github.com/behdad/region-flags/tree/gh-pages/png
// - It is supported by libphonenumber (it must be listed on this page): https://github.com/googlei18n/libphonenumber/blob/master/resources/ShortNumberMetadata.xml

// Each country array has the following information:
// [
//    Country name,
//    iso2 code,
//    International dial code,
//    Order (if >1 country with same dial code),
//    Area codes
// ]
const allCountriesFr: any[][] = [
    [
        'Afghanistan',
        'af',
        '93'
    ],
    [
        'Albanie',
        'al',
        '355'
    ],
    [
        'Algérie',
        'dz',
        '213'
    ],
    [
        'Samoa américaines',
        'as',
        '1'
    ],
    [
        'Andorre',
        'ad',
        '376'
    ],
    [
        'Angola',
        'ao',
        '244'
    ],
    [
        'Anguilla',
        'ai',
        '1'
    ],
    [
        'Antigua-et-Barbuda',
        'ag',
        '1'
    ],
    [
        'Argentine',
        'ar',
        '54'
    ],
    [
        'Arménie',
        'am',
        '374'
    ],
    [
        'Aruba',
        'aw',
        '297'
    ],
    [
        'Australie',
        'au',
        '61',
        0
    ],
    [
        'Autriche',
        'at',
        '43'
    ],
    [
        'Azerbaïjan',
        'az',
        '994'
    ],
    [
        'Bahamas',
        'bs',
        '1'
    ],
    [
        'Bahreïn',
        'bh',
        '973'
    ],
    [
        'Bangladesh',
        'bd',
        '880'
    ],
    [
        'Barbade',
        'bb',
        '1'
    ],
    [
        'Biélorussie',
        'by',
        '375'
    ],
    [
        'Belgique',
        'be',
        '32'
    ],
    [
        'Belize',
        'bz',
        '501'
    ],
    [
        'Bénin',
        'bj',
        '229'
    ],
    [
        'Bermudes',
        'bm',
        '1'
    ],
    [
        'Bhoutan',
        'bt',
        '975'
    ],
    [
        'Bolivie',
        'bo',
        '591'
    ],
    [
        'Bosnie-Herzégovine',
        'ba',
        '387'
    ],
    [
        'Botswana',
        'bw',
        '267'
    ],
    [
        'Brésil',
        'br',
        '55'
    ],
    [
        'Territoire britannique de l\'océan Indien',
        'io',
        '246'
    ],
    [
        'Îles Vierges britanniques',
        'vg',
        '1'
    ],
    [
        'Brunei',
        'bn',
        '673'
    ],
    [
        'Bulgarie',
        'bg',
        '359'
    ],
    [
        'Burkina Faso',
        'bf',
        '226'
    ],
    [
        'Burundi',
        'bi',
        '257'
    ],
    [
        'Cambodge',
        'kh',
        '855'
    ],
    [
        'Cameroun',
        'cm',
        '237'
    ],
    [
        'Canada',
        'ca',
        '1',
        1,
        ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905']
    ],
    [
        'Cap-Vert',
        'cv',
        '238'
    ],
    [
        'Pays-Bas caribéens',
        'bq',
        '599',
        1
    ],
    [
        'Îles Caïmans',
        'ky',
        '1'
    ],
    [
        'République centrafricaine',
        'cf',
        '236'
    ],
    [
        'Tchad',
        'td',
        '235'
    ],
    [
        'Chili',
        'cl',
        '56'
    ],
    [
        'Chine',
        'cn',
        '86'
    ],
    [
        'Île Christmas',
        'cx',
        '61',
        2
    ],
    [
        'Îles Cocos',
        'cc',
        '61',
        1
    ],
    [
        'Colombie',
        'co',
        '57'
    ],
    [
        'Comores',
        'km',
        '269'
    ],
    [
        'République démocratique du Congo',
        'cd',
        '243'
    ],
    [
        'République du Congo',
        'cg',
        '242'
    ],
    [
        'Îles Cook',
        'ck',
        '682'
    ],
    [
        'Costa Rica',
        'cr',
        '506'
    ],
    [
        'Côte d’Ivoire',
        'ci',
        '225'
    ],
    [
        'Croatie',
        'hr',
        '385'
    ],
    [
        'Cuba',
        'cu',
        '53'
    ],
    [
        'Curaçao',
        'cw',
        '599',
        0
    ],
    [
        'Chypre',
        'cy',
        '357'
    ],
    [
        'République tchèque',
        'cz',
        '420'
    ],
    [
        'Danemark',
        'dk',
        '45'
    ],
    [
        'Djibouti',
        'dj',
        '253'
    ],
    [
        'Dominique',
        'dm',
        '1'
    ],
    [
        'République dominicaine',
        'do',
        '1',
        2,
        ['809', '829', '849']
    ],
    [
        'Équateur',
        'ec',
        '593'
    ],
    [
        'Égypte',
        'eg',
        '20'
    ],
    [
        'Salvador',
        'sv',
        '503'
    ],
    [
        'Guinée équatoriale',
        'gq',
        '240'
    ],
    [
        'Érythrée',
        'er',
        '291'
    ],
    [
        'Estonie',
        'ee',
        '372'
    ],
    [
        'Éthiopie',
        'et',
        '251'
    ],
    [
        'Géorgie du Sud-et-les îles Sandwich du Sud',
        'fk',
        '500'
    ],
    [
        'Îles Féroé',
        'fo',
        '298'
    ],
    [
        'Fiji',
        'fj',
        '679'
    ],
    [
        'Finlande',
        'fi',
        '358',
        0
    ],
    [
        'France',
        'fr',
        '33'
    ],
    [
        'Guyane française',
        'gf',
        '594'
    ],
    [
        'Polynésie française',
        'pf',
        '689'
    ],
    [
        'Gabon',
        'ga',
        '241'
    ],
    [
        'Gambie',
        'gm',
        '220'
    ],
    [
        'Géorgie',
        'ge',
        '995'
    ],
    [
        'Allemagne',
        'de',
        '49'
    ],
    [
        'Ghana',
        'gh',
        '233'
    ],
    [
        'Gibraltar',
        'gi',
        '350'
    ],
    [
        'Grèce',
        'gr',
        '30'
    ],
    [
        'Groenland',
        'gl',
        '299'
    ],
    [
        'Grenade',
        'gd',
        '1'
    ],
    [
        'Guadeloupe',
        'gp',
        '590',
        0
    ],
    [
        'Guam',
        'gu',
        '1'
    ],
    [
        'Guatémala',
        'gt',
        '502'
    ],
    [
        'Guernesey',
        'gg',
        '44',
        1
    ],
    [
        'Guinée',
        'gn',
        '224'
    ],
    [
        'Guiné Bissau',
        'gw',
        '245'
    ],
    [
        'Guyana',
        'gy',
        '592'
    ],
    [
        'Haïti',
        'ht',
        '509'
    ],
    [
        'Honduras',
        'hn',
        '504'
    ],
    [
        'Hong Kong',
        'hk',
        '852'
    ],
    [
        'Hongrie',
        'hu',
        '36'
    ],
    [
        'Islande',
        'is',
        '354'
    ],
    [
        'Inde',
        'in',
        '91'
    ],
    [
        'Indonésie',
        'id',
        '62'
    ],
    [
        'Iran',
        'ir',
        '98'
    ],
    [
        'Iraq',
        'iq',
        '964'
    ],
    [
        'Ireland',
        'ie',
        '353'
    ],
    [
        'Île de Man',
        'im',
        '44',
        2
    ],
    [
        'Israël',
        'il',
        '972'
    ],
    [
        'Italie',
        'it',
        '39',
        0
    ],
    [
        'Jamaïque',
        'jm',
        '1'
    ],
    [
        'Japon',
        'jp',
        '81'
    ],
    [
        'Jersey',
        'je',
        '44',
        3
    ],
    [
        'Jordanie',
        'jo',
        '962'
    ],
    [
        'Kazakhstan',
        'kz',
        '7',
        1
    ],
    [
        'Kenya',
        'ke',
        '254'
    ],
    [
        'Kiribati',
        'ki',
        '686'
    ],
    [
        'Kosovo',
        'xk',
        '383'
    ],
    [
        'Koweït',
        'kw',
        '965'
    ],
    [
        'Kirghizistan',
        'kg',
        '996'
    ],
    [
        'Laos',
        'la',
        '856'
    ],
    [
        'Lettonie',
        'lv',
        '371'
    ],
    [
        'Liban',
        'lb',
        '961'
    ],
    [
        'Lesotho',
        'ls',
        '266'
    ],
    [
        'Liberia',
        'lr',
        '231'
    ],
    [
        'Libye',
        'ly',
        '218'
    ],
    [
        'Liechtenstein',
        'li',
        '423'
    ],
    [
        'Lituanie',
        'lt',
        '370'
    ],
    [
        'Luxembourg',
        'lu',
        '352'
    ],
    [
        'Macao',
        'mo',
        '853'
    ],
    [
        'Macédoine du Nord',
        'mk',
        '389'
    ],
    [
        'Madagascar',
        'mg',
        '261'
    ],
    [
        'Malawi',
        'mw',
        '265'
    ],
    [
        'Malaisie',
        'my',
        '60'
    ],
    [
        'Maldives',
        'mv',
        '960'
    ],
    [
        'Mali',
        'ml',
        '223'
    ],
    [
        'Malte',
        'mt',
        '356'
    ],
    [
        'Îles Marshall',
        'mh',
        '692'
    ],
    [
        'Martinique',
        'mq',
        '596'
    ],
    [
        'Mauritanie',
        'mr',
        '222'
    ],
    [
        'Maurice',
        'mu',
        '230'
    ],
    [
        'Mayotte',
        'yt',
        '262',
        1
    ],
    [
        'Mexique',
        'mx',
        '52'
    ],
    [
        'Micronésie',
        'fm',
        '691'
    ],
    [
        'Moldavie',
        'md',
        '373'
    ],
    [
        'Monaco',
        'mc',
        '377'
    ],
    [
        'Mongolie',
        'mn',
        '976'
    ],
    [
        'Monténégro',
        'me',
        '382'
    ],
    [
        'Montserrat',
        'ms',
        '1'
    ],
    [
        'Maroc',
        'ma',
        '212',
        0
    ],
    [
        'Mozambique',
        'mz',
        '258'
    ],
    [
        'Birmanie',
        'mm',
        '95'
    ],
    [
        'Namibie',
        'na',
        '264'
    ],
    [
        'Nauru',
        'nr',
        '674'
    ],
    [
        'Népal',
        'np',
        '977'
    ],
    [
        'Pays-Bas',
        'nl',
        '31'
    ],
    [
        'Nouvelle-Calédonie',
        'nc',
        '687'
    ],
    [
        'Nouvelle-Zélande',
        'nz',
        '64'
    ],
    [
        'Nicaragua',
        'ni',
        '505'
    ],
    [
        'Niger',
        'ne',
        '227'
    ],
    [
        'Nigeria',
        'ng',
        '234'
    ],
    [
        'Niue',
        'nu',
        '683'
    ],
    [
        'Île Norfolk',
        'nf',
        '672'
    ],
    [
        'Corée du Nord',
        'kp',
        '850'
    ],
    [
        'Îles Mariannes du Nord',
        'mp',
        '1'
    ],
    [
        'Norvège',
        'no',
        '47',
        0
    ],
    [
        'Oman',
        'om',
        '968'
    ],
    [
        'Pakistan',
        'pk',
        '92'
    ],
    [
        'Palaos',
        'pw',
        '680'
    ],
    [
        'Palestine',
        'ps',
        '970'
    ],
    [
        'Panama',
        'pa',
        '507'
    ],
    [
        'Papouasie-Nouvelle-Guinée',
        'pg',
        '675'
    ],
    [
        'Paraguay',
        'py',
        '595'
    ],
    [
        'Pérou',
        'pe',
        '51'
    ],
    [
        'Philippines',
        'ph',
        '63'
    ],
    [
        'Pologne',
        'pl',
        '48'
    ],
    [
        'Portugal',
        'pt',
        '351'
    ],
    [
        'Porto Rico',
        'pr',
        '1',
        3,
        ['787', '939']
    ],
    [
        'Qatar',
        'qa',
        '974'
    ],
    [
        'La Réunion',
        're',
        '262',
        0
    ],
    [
        'Roumanie',
        'ro',
        '40'
    ],
    [
        'Russie',
        'ru',
        '7',
        0
    ],
    [
        'Rwanda',
        'rw',
        '250'
    ],
    [
        'Saint Barthélemy',
        'bl',
        '590',
        1
    ],
    [
        'Saint-Helène',
        'sh',
        '290'
    ],
    [
        'Saint-Christophe-et-Niévès',
        'kn',
        '1'
    ],
    [
        'Sainte-Lucie',
        'lc',
        '1'
    ],
    [
        'Saint-Martin',
        'mf',
        '590',
        2
    ],
    [
        'Saint-Pierre-et-Miquelon',
        'pm',
        '508'
    ],
    [
        'Saint-Vincent-et-les-Grenadines',
        'vc',
        '1'
    ],
    [
        'Samoa',
        'ws',
        '685'
    ],
    [
        'Saint-Marin',
        'sm',
        '378'
    ],
    [
        'Sao Tomé-et-Principe',
        'st',
        '239'
    ],
    [
        'Arabie saoudite',
        'sa',
        '966'
    ],
    [
        'Sénégal',
        'sn',
        '221'
    ],
    [
        'Serbie',
        'rs',
        '381'
    ],
    [
        'Seychelles',
        'sc',
        '248'
    ],
    [
        'Sierra Leone',
        'sl',
        '232'
    ],
    [
        'Singapour',
        'sg',
        '65'
    ],
    [
        'Saint-Martin',
        'sx',
        '1721'
    ],
    [
        'Slovaquie',
        'sk',
        '421'
    ],
    [
        'Slovénie',
        'si',
        '386'
    ],
    [
        'Îles Salomon',
        'sb',
        '677'
    ],
    [
        'Somalie',
        'so',
        '252'
    ],
    [
        'Afrique du Sud',
        'za',
        '27'
    ],
    [
        'Corée du Sud',
        'kr',
        '82'
    ],
    [
        'Soudan du Sud',
        'ss',
        '211'
    ],
    [
        'Espagne',
        'es',
        '34'
    ],
    [
        'Sri Lanka',
        'lk',
        '94'
    ],
    [
        'Soudan',
        'sd',
        '249'
    ],
    [
        'Suriname',
        'sr',
        '597'
    ],
    [
        'Île Jan Mayen',
        'sj',
        '47',
        1
    ],
    [
        'Eswatini',
        'sz',
        '268'
    ],
    [
        'Suède',
        'se',
        '46'
    ],
    [
        'Suisse',
        'ch',
        '41'
    ],
    [
        'Syrie',
        'sy',
        '963'
    ],
    [
        'Taiwan',
        'tw',
        '886'
    ],
    [
        'Tadjikistan',
        'tj',
        '992'
    ],
    [
        'Tanzanie',
        'tz',
        '255'
    ],
    [
        'Thaïlande',
        'th',
        '66'
    ],
    [
        'Timor oriental',
        'tl',
        '670'
    ],
    [
        'Togo',
        'tg',
        '228'
    ],
    [
        'Tokelau',
        'tk',
        '690'
    ],
    [
        'Tonga',
        'to',
        '676'
    ],
    [
        'Trinité-et-Tobago',
        'tt',
        '1'
    ],
    [
        'Tunisie',
        'tn',
        '216'
    ],
    [
        'Turquie',
        'tr',
        '90'
    ],
    [
        'Turkménistan',
        'tm',
        '993'
    ],
    [
        'Îles Turques-et-Caïques',
        'tc',
        '1'
    ],
    [
        'Tuvalu',
        'tv',
        '688'
    ],
    [
        'Îles Vierges des États-Unis',
        'vi',
        '1'
    ],
    [
        'Ouganda',
        'ug',
        '256'
    ],
    [
        'Ukraine',
        'ua',
        '380'
    ],
    [
        'Émirats arabes unis',
        'ae',
        '971'
    ],
    [
        'Royaume-Uni',
        'gb',
        '44',
        0
    ],
    [
        'États-Unis',
        'us',
        '1',
        0
    ],
    [
        'Uruguay',
        'uy',
        '598'
    ],
    [
        'Ouzbékistan',
        'uz',
        '998'
    ],
    [
        'Vanuatu',
        'vu',
        '678'
    ],
    [
        'Vatican City',
        'va',
        '379'
    ],
    [
        'Venezuela',
        've',
        '58'
    ],
    [
        'Việt Nam',
        'vn',
        '84'
    ],
    [
        'Wallis-et-Futuna',
        'wf',
        '681'
    ],
    [
        'Sahara occidental',
        'eh',
        '212',
        1
    ],
    [
        'Yémen',
        'ye',
        '967'
    ],
    [
        'Zambie',
        'zm',
        '260'
    ],
    [
        'Zimbabwe',
        'zw',
        '263'
    ],
    [
        'Îles Åland',
        'ax',
        '358',
        1
    ]
];

export const allCountriesOptionsFr: MCountryOptions[] = allCountriesFr.map(country => ({
    name: country[0],
    iso2: country[1],
    dialCode: country[2],
    priority: country[3] || 0,
    areaCodes: country[4] || undefined
}));


export default allCountriesOptionsFr;
